import React from "react";
import { connect } from "react-redux";
import { List } from "immutable";
import { history } from "/app/src/store";
import { Flex, Pagination } from "/app/src/component";
import Item from "./Item";
import style from "./style.css";
import UserModel from "/app/src/model/User/model";
import CustomerModel from "/app/src/model/Customer/model";
import UserSelector from "/app/src/model/User/selector";
import EmployeeSelector from "/app/src/model/Employee/selector";
import DateTime from "/app/src/lib/DateTime";

import getQueryVariable from "/app/src/lib/urlparser";

import Spinner from "/app/src/component/Spinner";

class SearchTicket extends React.Component {
  constructor(props) {
    super(props);
    this._renderResults = this._renderResults.bind(this);
    this._onPaginationClick = this._onPaginationClick.bind(this);
    this._onItemClick = this._onItemClick.bind(this);

    this.state = {
      currentPage: 1,
      activeItemId: "",
    };
  }

  render() {
    const resultsHeader = List([
      "Ärende ID",
      "Besökar ID",
      "Medarbetare",
      "Skapat",
      "Avklarat",
    ]);
    return (
      <Flex column grow>
        {this._renderHeader(resultsHeader)}
        {this.props.searchIsFetching ? (
          <Flex center basis="30vh">
            <Spinner />
          </Flex>
        ) : (
          this._renderResults()
        )}
      </Flex>
    );
  }

  _renderHeader(resultsHeader) {
    return (
      <Flex className={style.sorting} shrink={0}>
        {resultsHeader.map((e, i) => (
          <Flex center width="20%" key={i}>
            {e}
          </Flex>
        ))}
      </Flex>
    );
  }

  _onItemClick(room, participants) {
    const terms = getQueryVariable(this.props.location.search, "terms");
    const ids = participants
      .filter((participant) => participant.get("type") === "customer")
      .map((participant) => participant.get("id"));

    this.props.dispatch(CustomerModel.readFromDB(ids));
    this.setState({ activeItemId: room });
    history.push({
      search: `terms=${terms}&room=${room}`,
    });
  }

  _renderPagination() {
    return (
      <Flex>
        <Pagination
          marginTop="auto"
          itemCounts={this.props.resultCount}
          itemPerPage={10}
          currentPage={this.state.currentPage}
          onClick={this._onPaginationClick}
        />
      </Flex>
    );
  }

  _renderResults() {
    const searchResults = this.props.searchResults;
    const terms = getQueryVariable(this.props.location.search, "terms");

    if (searchResults.size === 0)
      return (
        <Flex grow center height="30vh">
          {`Din sökning på "${terms}" på matchade inga resultat. Kontrollera sökorden.`}
        </Flex>
      );
    return (
      <Flex column width="100%" overflow="auto" basis="max-content">
        {searchResults.map((e, index) => (
          <Item
            key={index}
            companyTicketId={e["companyTicketId"]}
            id={e["room"]}
            activeItemId={this.state.activeItemId}
            companyCustomerId={e["companyCustomerId"]}
            coworkerName={e["coworkerName"]}
            created={e["timeTicketCreated"]}
            resolved={e["timeTicketResolved"]}
            onClick={() => this._onItemClick(e["room"], e["participants"])}
          />
        ))}
        {this.props.resultCount > 10 && this._renderPagination()}
      </Flex>
    );
  }

  _onPaginationClick() {
    const terms = getQueryVariable(this.props.location.search, "terms");
    history.push({
      search: `terms=${terms}`,
    });
    this.props.dispatch(
      UserModel.searchBy(terms.split(" "), this.state.currentPage)
    );
  }
}

function mapStateToProps(state, ownProps) {
  const results = UserSelector.searchResults(state).get("tickets");
  const count = UserSelector.searchResults(state).get("tickets_total_count");
  let resultdata = [];
  if (results) {
    resultdata = results.map((result) => {
      const employeeId = result.get("assigned_employee_id");
      const employee = EmployeeSelector.getById(state, employeeId);
      const employeeName = EmployeeSelector.getName(employee);

      return {
        companyTicketId: result.get("company_ticket_id"),
        companyCustomerId: result.get("company_customer_id"),
        coworkerName: employeeName,
        timeTicketCreated: DateTime.formatDate(
          result.get("date_created"),
          "yyyy-mm-dd"
        ),
        timeTicketResolved: DateTime.formatDate(
          result.get("date_resolved"),
          "yyyy-mm-dd"
        ),
        room: result.get("room"),
        participants: result.get("participants"),
      };
    });
  }

  return {
    searchResults: resultdata,
    searchIsFetching: UserSelector.searchIsFetching(state),
    resultCount: count,
  };
}
export default connect(mapStateToProps, null)(SearchTicket);



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/Search/Ticket/index.js